import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { useFiltersForm } from 'hooks/useFiltersForm';
import { getCurrencyCode } from 'modules/meta/selectors';
import { showPriceFilter } from 'modules/overlay/actions';
import { searchParamToFacet } from 'modules/search/constants';
import { prop } from 'ramda';
import Settings from 'Settings';
import { Pill } from '@daedalus/atlas/Pill';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { getEnabledCurrencies } from '@daedalus/core/src/localization/business/currency';
import { PriceFilterBottomSheet } from './PriceFilterBottomSheet';
const filterKeys = [searchParamToFacet.priceMin.param, searchParamToFacet.priceMax.param];
const ActiveLabel = /*#__PURE__*/styled('span')({
  name: "ActiveLabel",
  class: "a2zn74d",
  propsAsIs: false
});
interface Props {
  isActive?: boolean;
}
export const PriceFilterPill: React.FC<Props> = ({
  isActive = false
}) => {
  const dispatch = useDispatch();
  const {
    formatMessage
  } = useIntl();
  const {
    getAppliedFilters,
    trackFilterClick
  } = useFiltersForm(filterKeys, 'price');
  const currencyCode = useSelector(getCurrencyCode);
  const enabledCurrencies = getEnabledCurrencies(Settings.get('ENABLED_CURRENCIES'));
  const currency = enabledCurrencies.find(currency => currency.code === currencyCode);
  const currencySymbol = prop('symbol', currency);
  const {
    priceMin: appliedPriceMin,
    priceMax: appliedPriceMax
  } = getAppliedFilters();
  const buildActiveLabel = useCallback(() => <ActiveLabel>
        {currencySymbol}
        {appliedPriceMin} - {currencySymbol}
        {appliedPriceMax}
      </ActiveLabel>, [currencySymbol, appliedPriceMin, appliedPriceMax]);
  const handleOnPillClick = () => {
    dispatch(showPriceFilter());
    trackFilterClick({
      category: Category.User,
      entity: Entity.FilterButton,
      action: Action.Clicked,
      payload: {
        selectedElement: 'quickFilterprice'
      }
    });
  };
  const label = isActive ? buildActiveLabel() : formatMessage({
    id: 'priceFilter',
    defaultMessage: 'Price'
  });
  return <>
      <Pill dataId="priceFilter" onClick={handleOnPillClick} isSelected={isActive} showArrow>
        {label}
      </Pill>
      <PriceFilterBottomSheet />
    </>;
};

require("./PriceFilterPill.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceFilterPill.tsx");